module.exports = __webpack_public_path__ + "static/img/veteran2.f92629c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/veteran2.png
// module id = 6jgB
// module chunks = 0